import {
  HAS_CHANGED_PROFILE,
  PROFILE_SWITCH,
  REGISTER_IDS,
  PROFILE_DETAIL,
  STORE_DEVICE_TOKEN,
  PROFILE_COMPLETION_FLAGS,
  ACTIVE_LOGIN_TYPE,
  ACTIVE_SUBSCRIPTION,
  PREFFERED_CURRENCY,
  DELETE_IDS,
  DELETE_FCM,
  ACTIVE_PROFILES,
  RESET_STORE,
  ACCESS_DATA,
  STORE_PASSWORD,
  AI_SCORE,
  PROFILE_JOURNEY_INFO
} from "./action";

const initialState = {
  profileSwitchList: [],
  hasChangeFlag: false,
  CurrentRegistrationIds: {},
  FCMDeviceToken: "",
  storedPrefferedCurrency: null,
  storeActiveSubscription: null,
  storeActiveLoginType: {
    login_type: "",
    account_type: "",
  },
  storeSubscriptionFlags: {
    has_active_subscription: false,
    has_subscription_expired: false,
  },
  profileCompletionFlags: {
    has_active_subscription: false,
    has_subscription_expired: false,
    has_free_subscription: false,
    has_investment_profile_completed: false,
    has_want_to_sell_profile_completed: false,
    has_want_to_grow_profile_completed: false,
    has_investor_profile_completed: false,
    has_investment_subscription: false,
    has_want_to_sell_subscription: false,
    has_want_to_grow_subscription: false,
    has_investor_subscription: false,
    has_investment_free_subscription: false,
    has_want_to_sell_free_subscription: false,
    has_want_to_grow_free_subscription: false,
    has_investor_free_subscription: false,
    has_investment_subs: false,
    has_want_to_sell_subs: false,
    has_want_to_grow_subs: false,
    has_investor_subs: false,
  },
  active_profile: {
    has_investment: 0,
    has_investor: 0,
    has_want_to_grow: 0,
    has_want_to_sell: 0,
  },
  store_password: "",
  ai_score: null,
  profile_journey_info: null,
};

export const storeReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case RESET_STORE:
      return initialState;
    case PROFILE_SWITCH:
      return {
        ...state,
        profileSwitchList: action.payload,
      };
    case PROFILE_DETAIL:
      return {
        ...state,
        profileDetail: action.payload,
      };
    case HAS_CHANGED_PROFILE:
      return {
        ...state,
        hasChangeFlag: action.payload,
      };
    case STORE_DEVICE_TOKEN:
      return {
        ...state,
        FCMDeviceToken: action.payload,
      };
    case REGISTER_IDS:
      return {
        ...state,
        CurrentRegistrationIds: action.payload,
      };
    case DELETE_IDS:
      const { CurrentRegistrationIds, ...rest } = state;
      return rest;

    case DELETE_FCM:
      const { FCMDeviceToken, ...rest1 } = state;
      return rest1;

    case PREFFERED_CURRENCY:
      return {
        ...state,
        storedPrefferedCurrency: action.payload,
      };
    case ACTIVE_SUBSCRIPTION:
      return {
        ...state,
        storedActiveSubscription: action.payload,
      };
    case ACTIVE_LOGIN_TYPE:
      return {
        ...state,
        storeActiveLoginType: action.payload,
      };
    case PROFILE_COMPLETION_FLAGS:
      return {
        ...state,
        profileCompletionFlags: action.payload,
      };

    case ACTIVE_PROFILES:
      return {
        ...state,
        active_profiles: action.payload,
      };

    case ACCESS_DATA:
      return {
        ...state,
        profile_access: action.payload,
      };
    case STORE_PASSWORD:
      return {
        ...state,
        store_password: action.payload,
      };
      case AI_SCORE:
      return {
        ...state,
        ai_score: action.payload,
      };
      case PROFILE_JOURNEY_INFO:
        return {
          ...state,
          profile_journey_info: action.payload,
        };
    default:
      return state;
  }
};
